<script>
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions([
      "postGarageMessage",
    ])
  },
  computed: {
    ...mapGetters({}),
  },
}
</script>
